import { ToastProgrammatic as Toast } from 'buefy';

export default function messageInformation(message, type) {
  let typeInfo = 'is-info';
  if (type) {
    typeInfo = type;
  }
  Toast.open({
    duration: 3000,
    message: message,
    position: 'is-top',
    type: typeInfo,
  });
}
